import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useExportAllSitreps } from 'components/Reports/utils/reportsExportHelpers';
import type { GetSitrepsResponse } from 'components/Reports/reports.types';

type ReportsExportButtonProps = {
  sitreps: GetSitrepsResponse[];
  filterName: string | null;
};

const ReportsExportButton: React.FC<ReportsExportButtonProps> = ({
  sitreps,
  filterName,
}) => {
  const { exportAllSitreps, isExporting } = useExportAllSitreps();

  const isDisabled = filterName === null || isExporting;

  const handleExport = async (format: 'pdf' | 'docx') => {
    await exportAllSitreps(sitreps, filterName, format);
  };

  return (
    <Dropdown className="dropdown-actions">
      <Dropdown.Toggle
        as={StylishNewButton}
        className="button--secondary reports-view__export-trigger"
        disabled={isDisabled}
        aria-label="Export Reports"
        title="Export Reports"
      >
        <SharedIcon iconName="download" size="md" />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        <Dropdown.Item onClick={() => handleExport('pdf')}>
          Export as PDF
        </Dropdown.Item>
        <Dropdown.Item onClick={() => handleExport('docx')}>
          Export as Word
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ReportsExportButton;
